import { filterSelectInput } from "components/form/DefaultConsultView/components/FilterInputs";
import Entity from "entity";

export default class Cultura extends Entity {
    static get collectionUID() {
        return "ValueCustomForm/kZCtbF5Qnly7qWPIwrTC/Values";
    }

    static async onQuery(collection) {
        return collection.where("status", "==", "ATIVO");
    }

    async initialize() {
        this.data.status = "ATIVO"
    }

    static get labelField() {
        return "cultura";
    }

    static get searchColumns() {
        return [
            { field: "sequencialIndex", headerName: "Código", flex: 1, filter: true },
            {
                field: "status", headerName: "Status", flex: 1, filter: filterSelectInput("status", "Status", ["ATIVO", "INATIVO"])
            },
            { field: "cultura", headerName: "Cultura", flex: 2, filter: true },
        ];
    }
}
